module.exports = __webpack_public_path__ + "static/img/team_honor_order_16.79e5807e.png";